module.exports = __webpack_public_path__ + "img/banner1.860d5773.png";